// extracted by mini-css-extract-plugin
export default {"locationGroup":"_21vyG","tanakLocationGroup":"_16qLm","locationGroupLevel0":"_1QNTC"};